import { Modal, ListGroup } from "react-bootstrap";
import { FaCommentAlt, FaUsers, FaChartBar, FaSignInAlt } from "react-icons/fa";
import { useHistory } from "react-router-dom";

/**
 * Modal "Ações do Canal" — replica menu do OrbitSender com 4 atalhos
 * pra outras telas, com o canal escolhido pré-selecionado quando aplicável.
 */
export default function ActionsModal({ show, channel, onClose }) {
  const history = useHistory();
  if (!channel) return null;

  function go(path) {
    onClose();
    history.push(path);
  }

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>⚡ Ações do Canal</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small mb-2">{channel.name}</p>
        <ListGroup>
          <ListGroup.Item
            action
            onClick={() => go("/admin/whatsapp-web/quick-sender")}
          >
            <FaCommentAlt className="mr-2" /> <strong>Quick Sender</strong>
            <div className="small text-muted">Disparo único pra um segmento</div>
          </ListGroup.Item>
          <ListGroup.Item
            action
            onClick={() => go("/admin/whatsapp-web/grupos")}
          >
            <FaUsers className="mr-2" /> <strong>Grupos</strong>
            <div className="small text-muted">
              Ver e sincronizar grupos do canal
            </div>
          </ListGroup.Item>
          <ListGroup.Item
            action
            onClick={() => go("/admin/whatsapp-web/multi-sender")}
          >
            <FaSignInAlt className="mr-2" /> <strong>Multi Sender</strong>
            <div className="small text-muted">
              Cole 50 URLs e gere campanhas em massa
            </div>
          </ListGroup.Item>
          <ListGroup.Item
            action
            onClick={() => go("/admin/whatsapp-web/estatisticas")}
          >
            <FaChartBar className="mr-2" /> <strong>Estatísticas</strong>
            <div className="small text-muted">
              Métricas e desempenho por canal
            </div>
          </ListGroup.Item>
        </ListGroup>
      </Modal.Body>
    </Modal>
  );
}
